// extracted by mini-css-extract-plugin
module.exports = {"root":"form_root__1FTKk","row":"form_row__2ugNM","save":"form_save__3WMJv","cancel":"form_cancel__3z1Vg","error":"form_error__1Y_yv"};